<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <router-link class="nav-link" to="/logout">
        <span class="no-icon">Log out</span>
      </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'mobile-menu'
}
</script>
<style>
</style>
